import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
  parsePhoneNumber,
  ParseError,
} from 'libphonenumber-js';

export const formatPhoneNumberWithError = (
  number: string,
): { number: string | null; error: string | null } => {
  try {
    const parsedNumber = parsePhoneNumberWithError(number, 'US');
    if (!parsedNumber.isValid()) {
      return {
        number: null,
        error: 'Invalid phone number',
      };
    }
    return {
      number: parsedNumber.number,
      error: null,
    };
  } catch (err) {
    return {
      number: null,
      error: err instanceof ParseError ? err.message : 'Unknown error',
    };
  }
};

export const processPhoneNumber = (number: string) => {
  const formattedNumber = `${number.includes('+') ? '' : '+'}${number}`;

  if (!isValidPhoneNumber(formattedNumber)) return number;

  const phoneNumber = parsePhoneNumber(formattedNumber);
  return phoneNumber?.formatInternational() ?? '';
};

export const getFirstAndLastFourUUID = (uuid: string) => {
  if (!uuid) return '';
  return `${uuid.slice(0, 4)}....${uuid.slice(-4)}`;
};

export const extractDigits = (value: string) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};
